import { Button, Tooltip } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import moment from 'moment';
import React from 'react';

import { EditNoteIcon } from '@/components/UI/iconComponents';

import styles from './index.module.scss';
import type { EdutainmentOrder } from './types';

export const getOrderTableColumns = (
  handleCancelButtonClick: (orderId: string) => void,
  handleEditNoteButtonClick: (orderId: string) => void
) => {
  const columns: ColumnsType<EdutainmentOrder> = [
    {
      title: '育樂名稱',
      dataIndex: 'programName',
    },
    {
      title: '狀態',
      dataIndex: 'status',
    },
    {
      title: '訂單編號',
      dataIndex: 'orderNumber',
    },
    {
      title: '下單時間(年/月/日)',
      dataIndex: 'createdTime',
      render: (timestamp) => {
        return moment(timestamp).format('YYYY/MM/DD');
      },
    },
    {
      title: '會員',
      dataIndex: 'memberName',
    },
    {
      title: '手機號碼',
      dataIndex: 'phoneNumber',
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    },
    {
      title: '付費方式',
      dataIndex: 'payment',
    },
    {
      title: '金額',
      dataIndex: 'price',
      render: (number, record) => {
        if (record.payment === '點數') {
          return number + '點';
        }
        return number + '元';
      },
    },
    {
      title: '滿意度(5星)',
      dataIndex: 'rating',
      render: (rating) => {
        return '⭐'.repeat(rating);
      },
    },
    {
      title: '評價',
      dataIndex: 'review',
      width: 200,
      ellipsis: {
        showTitle: false,
      },
      render: (review) => (
        <Tooltip placement="topLeft" title={review}>
          {review}
        </Tooltip>
      ),
    },
    {
      title: '操作',
      dataIndex: 'actions',
      fixed: 'right',
      render: (_, record) => {
        return (
          <Button
            type="primary"
            danger
            disabled={!record.cancelable}
            onClick={() => handleCancelButtonClick(record._id)}
          >
            取消
          </Button>
        );
      },
    },
    {
      title: '備註',
      dataIndex: 'note',
      fixed: 'right',
      render: (_, record) => {
        return (
          <button
            className={styles.iconButton}
            onClick={() => handleEditNoteButtonClick(record._id)}
          >
            <EditNoteIcon />
            {record.hasNotes && <div className={styles.redCircle} />}
          </button>
        );
      },
    },
  ];

  return columns;
};
